export const USER_DATA_DRAWER_EXPANSION_KEY = 'user-data-drawer';
export const DATA_TEST_DYNAMIC_HEATMAP_TABLE = 'dynamic-heatmap-table';
export const DATA_FEED_BANNER_TEXT =
  'Data feeds are uncached, so this preview may not represent the actual data shown to the user on send.';
export const DATA_TEST_PREVIEW_HEADER_USER_DATA = 'preview-header-user-data';
export const DATA_TEST_JSON_TOGGLE = 'json-toggle';
export const DATA_TEST_PREVIEW_HEADER_DATA_FEEDS = 'preview-header-data-feeds';
export const TEMPLATE_PREVIEW_HEADER = 'template-preview-header';
